// Returns a promise that resolves after a specified number of milliseconds.
export default (ms: number): Promise<void> =>
    new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
